export default {
  title: "vision catalogue".toUpperCase(),
}
